/* Catalog */
import '../partials/catalog/catalog';

import ReadMore from '../js/readmore';

ReadMore.init();
